export default __webpack_public_path__ + "static/media/globe-icon.26ce0b50.svg";